import { LocalizationMap, ProgressBar, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { useEffect, useState } from 'react';
import 'pdfjs-dist/build/pdf.worker.entry';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import pt_PT from '@react-pdf-viewer/locales/lib/pt_PT.json';
import english from '@react-pdf-viewer/locales/lib/en_US.json';
import queryString from 'query-string';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import { Box, CircularProgress, css, Typography } from '@mui/material';

import { RenderError } from 'features/pdf/components/RenderError';
import { PDFToolbar } from './PDFToolbar';
import { useSessionStore } from 'session/useSessionStore';

const style = css({
    height: '100vh'
});

export function PDFViewer() {
    const [url, setUrl] = useState<string>('');
    const queryParams = queryString.parse(window.location.search);

    const { tenantConfig, jwtToken } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration,
        jwtToken: state.jwtToken
    }));

    useEffect(() => {
        if (queryParams.source === 'file-manager') {
            if (queryParams.fileToken && typeof queryParams.fileToken === 'string') {
                const buildUrl = `${tenantConfig?.endpoints.fileManager}/filemanager/filemanager/downloadFile?&fileToken=${queryParams.fileToken}`;
                setUrl(buildUrl);
            }
            else {
                console.error('params invalido');
            }
        }
        else if (queryParams.source === 'pgs-cognite') {
            if (queryParams.fileToken && typeof queryParams.fileToken === 'string') {
                const buildUrl = `${tenantConfig?.endpoints.render}/seismic/product/downloadFile?fileId=${queryParams.fileToken}`;
                setUrl(buildUrl);
            }
            else {
                console.error('params invalido');
            }
        }
        else if (queryParams.source === 'file-indexing') {
            if (queryParams.fileToken && typeof queryParams.fileToken === 'string' && (queryParams.fileType === 'tif' || queryParams.fileType === 'tiff')) {
                const buildUrl = `${tenantConfig?.endpoints.fileManager}/FileManager/FileManager/ConvertTiffToMultiPagePdf?fileToken=${queryParams.fileToken}`;
                setUrl(buildUrl);
            }
            else {
                const buildUrl = `${tenantConfig?.endpoints.fileManager}/FileManager/FileManager/GetFileForViewer?fileToken=${queryParams.fileToken}`;
                setUrl(buildUrl);
            }
        }
        else {
            console.error('source inválido');
        }
    }, []);

    const renderToolbar = PDFToolbar;

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar,
        sidebarTabs: (defaultTabs) => [
            defaultTabs[0],
        ],
    });

    return (
        <Box css={style}>
            {(url !== '' && jwtToken !== '') ?
                <Viewer
                    renderLoader={(percentages: number) => (
                        <Box style={{ width: '240px' }}>
                            {(percentages === 0 && (queryParams.fileType === 'tif' || queryParams.fileType === 'tiff')) ?
                                (<Typography style={{color: '#ffffff', textAlign: 'center'}}>The file is being prepared, it could take a while</Typography>) :
                                (<ProgressBar progress={Math.round(percentages)} />)
                            }
                        </Box>
                    )}
                    localization={english as unknown as LocalizationMap}
                    defaultScale={1}
                    theme="dark"
                    fileUrl={url}
                    plugins={[defaultLayoutPluginInstance]}
                    renderError={RenderError}
                    httpHeaders={{
                        Authorization: `Bearer ${jwtToken}`,
                    }} /> :
                <Box>Preparing...</Box>
            }
        </Box>
    );
}